import React from "react"
import { VideoURL, VideoVimeo, VideoYouTube } from "@components/sections"

/**
 * Video section
 * @param {object} props - React props
 */
const Video = props => {
  const { color, theme, title, vimeoId, youTubeId, videoUrl, preview } = props

  if (videoUrl) return <VideoURL src={videoUrl} />

  if (youTubeId) return <VideoYouTube youTubeId={youTubeId} />

  if (vimeoId)
    return (
      <VideoVimeo color={color} theme={theme} title={title} preview={preview} vimeoId={vimeoId} />
    )

  return <>No Video </>
}

export default Video
